<template>
  <div class="contain">
    <div class="top">
      <div class="login-out" @click="loginOut" v-if="tel">退出登录</div>
      <img class="imgsize1" :src="my_bgi" mode="" />
      <div class="card">
        <div class="header flex-direction-row">
          <img :src="tx" class="imgsize3" mode="" />
          <div class="h-left flex-direction-column">
            <div class="title" v-if="userName">{{ userName }}</div>
            <div class="title" v-if="tel">
              {{ tel }}
            </div>
            <div class="title" v-else @click="goLogin">去登录</div>
          </div>
        </div>
      </div>
    </div>
    <div class="centerbox c-box">
      <div class="cellbox">
        <div
          v-for="(i, index) in listdata2"
          class="flex-direction-column"
          :key="index + 'c'"
          @click="handMethods(i.changeYemian)"
        >
          <div class="cellbox-item flex-direction-row">
            <img :src="i.imgurl" class="iconimg" mode="" />
            <p>{{ i.listname }}</p>
            <van-icon name="arrow" size="16" />
          </div>
          <div class="henxian" v-if="i.changeYemian !== 'changeyinsi2'"></div>
        </div>
      </div>
    </div>
    <van-dialog
      id="van-dialog"
      z-index="-1"
      confirm-button-color="#438fe6"
      :show="show"
    />
    <TabBar></TabBar>
  </div>
</template>
<script>
import TabBar from "@/components/TabBar/IndexTabBar.vue";
import { mapState } from "vuex";
import { Dialog } from "vant";
export default {
  data() {
    return {
      show: false,
      userName: "",
      tel: "",
      my_bgi: require("../assets/images/model-com/my_bgi.png"),
      tx: require("../assets/images/model-com/tx.png"),
      model1: require("../assets/images/model-com/a2.png"),
      listdata2: [
        {
          imgurl: require("../assets/images/model-com/item1.3.png"),
          listname: "联系客服",
          changeYemian: "openKefu",
        },
        {
          imgurl: require("../assets/images/model-com/item1.4.png"),
          listname: "隐私协议",
          changeYemian: "goPrivacy",
        },
      ],
    };
  },
  computed: {
    ...mapState("user", ["userInfo"]),
  },
  mounted() {
    this.$store.dispatch("tabbar/sendAcive", 1);
    this.tel = this.userInfo.mobileNo;
    this.userName = this.userInfo.userName;
  },
  components: {
    TabBar,
  },
  methods: {
    handMethods(e) {
      switch (e) {
        case "openKefu":
          // 执行go1方法
          this.openKefu();
          break;
        case "goPrivacy":
          // 执行go1方法
          this.goPrivacy();
          break;
      }
    },
    goPrivacy() {
      this.$router.push({
        name: "protocol",
        params: {
          data: {
            xieyiCode: "YSYAQ",
            title: "隐私协议",
          },
        },
      });
    },
    openKefu() {
      this.$store.dispatch("user/OpenKefu");
    },
    goLogin() {
      this.$go("/");
    },
    loginOut() {
      Dialog.confirm({
        title: "温馨提示",
        message: "确认退出登录吗.",
        confirmButtonColor: "#0065ff",
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(() => {
        this.$store.dispatch("user/logout");
      });
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="less" scoped>
.contain {
  width: 100%;
  min-height: 100vh;
  background: #f7f8f9;
}

.img-margin {
  margin-right: 5px;
}

.top {
  width: 100%;
  height: 260.27px;
  position: relative;
  padding: 35px 15px 0;
  box-sizing: border-box;

  .login-out {
    position: absolute;
    right: 0;
    z-index: 9999;
    font-weight: bold;
    font-size: 13px;
    color: #29cd9d;
    padding: 3px 11px 4px 12px;
    top: 62px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 80px 0px 0px 80px;
  }

  .imgsize1 {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }

  .card {
    width: 345px;
    position: relative;
    border-radius: 10px;
    z-index: 1;
    padding: 23px 17px 14px 19px;
    box-sizing: border-box;
  }
}

.header {
  .h-left {
    margin-left: 9px;
    height: 63px;
    justify-content: space-around;

    .title {
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
    }
  }
}

.imgsize2 {
  width: 80px;
  height: 22px;
}

.imgsize3 {
  width: 64px;
  height: 64px;
}

.body {
  display: flex;
  justify-content: space-between;
  margin-top: 62px;

  .b-box {
    width: 50%;
    align-items: center;
    position: relative;
  }

  .b-box:nth-child(1)::before {
    content: "";
    width: 2px;
    height: 34px;
    background: #eeeeee;
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
  }

  .b-box p:nth-child(1) {
    font-weight: bold;
    font-size: 34px;
    color: #29cd9d;
    line-height: 38px;
  }

  .b-box p:nth-child(2) {
    font-weight: 500;
    font-size: 22px;
    color: #b1b1b1;
    line-height: 23px;
    margin-top: 4px;
  }
}

.cellbox {
  margin-top: 15px;
  width: 95%;
  border-radius: 18px;
  background-color: #ffffff;
}

.cellbox-item {
  width: 100%;
  height: 60px;
  padding: 0 20px;
  box-sizing: border-box;
  justify-content: space-between;
}

.iconimg2 {
  width: 8px;
  height: 13px;
}

.cellbox-item p {
  font-size: 17px;
  display: block;
  width: 80%;
  font-weight: 500;
  color: #333333;
  line-height: 20px;
}

.iconimg {
  width: 20px;
  height: 20px;
}

.c-box {
  position: relative;
  z-index: 1;
  margin-top: -87px;
}
</style>
